import { render, staticRenderFns } from "./OtherTeamIndex.vue?vue&type=template&id=2d12cd5c&"
import script from "./OtherTeamIndex.vue?vue&type=script&lang=js&"
export * from "./OtherTeamIndex.vue?vue&type=script&lang=js&"
import style0 from "./OtherTeamIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VCol,VMain,VRow})
